<template>
  <div class="video__wrapper" :style="{ 'padding-top': `${padding}%` }">
    <iframe
    :src="`https://player.vimeo.com/video/${vimeo}?h=84e4e5903f&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479`"
    frameborder="0"
    allow="autoplay; fullscreen; picture-in-picture"
    class="video__iframe"
  ></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      padding: { type: Number },
      vimeo: { type: Number },
    },
    mounted() {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      document.body.appendChild(script);
    },
  };
</script>